import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdmin } from "../../context/AdminContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setAdmin } = useAdmin();

  const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // 1. Login request
      const response = await fetch(`${BASE_URL}/api/admin/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const loginData = await response.json();

      if (!response.ok) {
        setError(loginData.message || "Login failed");
        setLoading(false);
        return;
      }

      // 2. ✅ Immediately fetch profile after login (cookie should now be set)
      const profileRes = await fetch(`${BASE_URL}/api/admin/profile`, {
        credentials: "include",
      });

      const profileData = await profileRes.json();

      if (!profileRes.ok) {
        console.error("Failed to fetch admin profile after login:", profileData);
        setError("Login succeeded but failed to load admin profile.");
        setLoading(false);
        return;
      }

      // 3. ✅ Set full admin context
      setAdmin(profileData);

      // 4. ✅ Navigate to dashboard
      navigate("/admin/dashboard");

      setTimeout(() => {
        window.location.reload();
      }, 150);

    } catch (err) {
      console.error("Login error:", err);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-6">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-xl shadow w-full max-w-md"
      >
        <div className="flex justify-center mb-4">
          <img src="/images/logos/Exudee-logo.svg" alt="Logo" className="h-16" />
        </div>

        <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>

        {error && (
          <div className="bg-red-100 text-red-600 text-sm px-3 py-2 rounded mb-4">
            {error}
          </div>
        )}

        <input
          type="email"
          placeholder="Email"
          className="w-full p-2 border mb-4 rounded"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (error) setError("");
          }}
          required
        />

        <input
          type="password"
          placeholder="Password"
          className="w-full p-2 border mb-4 rounded"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (error) setError("");
          }}
          required
        />

        <button
          type="submit"
          className="w-full bg-gray-800 text-white p-2 rounded hover:bg-gray-700 disabled:opacity-60"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}
